import { Reducer } from 'redux'

import { OrganizationsActionTypes, OrganizationsState } from './types'

const INITIAL_STATE: OrganizationsState = {
  error: false,
  list: [],
  loading: false
}

const reducer: Reducer<OrganizationsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case OrganizationsActionTypes.GET_ORGANIZATIONS:
      return {
        ...state,
        error: false,
        loading: true
      }
    case OrganizationsActionTypes.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [...payload.organizations]
      }
    case OrganizationsActionTypes.GET_ORGANIZATIONS_FAILURE:
      return {
        ...state,
        error: true,
        loading: false
      }

    /**
     * DEFAULT
     */
    default:
      return state
  }
}

export default reducer
